import Hero from "../sections/Hero";
import About from "../sections/About";
import Method from "../sections/Method";
import Pricing from "../sections/Pricing";
import Transformations from "../sections/Transformations";
import Reviews from "../sections/Reviews";
import CoachingVipSection from "../sections/CoachingVipSection";
import AppFeatures from "../sections/AppFeatures";
import Sponsors from "../sections/Sponsors";
import FaqSection from "../sections/FaqSection";
import ContactSection from "../sections/ContactSection";
import Marquee from "../components/Marquee";

const Home = () => (
  <main data-testid="rnb-home-page">
    <Hero />
    <About />
    <Method />
    <Pricing />
    <Transformations />
    <Marquee />
    <CoachingVipSection />
    <Reviews />
    <AppFeatures />
    <Sponsors />
    <FaqSection />
    <ContactSection />
  </main>
);

export default Home;
